import { render, staticRenderFns } from "./SetListItem.vue?vue&type=template&id=6bbc18cf&scoped=true"
import script from "./SetListItem.vue?vue&type=script&lang=js"
export * from "./SetListItem.vue?vue&type=script&lang=js"
import style0 from "./SetListItem.vue?vue&type=style&index=0&id=6bbc18cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc18cf",
  null
  
)

export default component.exports